import type * as React from 'react';
import { isMac } from 'owa-user-agent';

export default function isCtrlOrCmdKeyDown<T, E>(e: React.MouseEvent<T, E>) {
    return isMac() ? e.metaKey : e.ctrlKey;
}
